<div [ngClass]="['bento-grid', className]">
  <ng-content></ng-content>
</div>
